import AxiosBusiness from '@/services/api/business/axios_business'

export default {
  createCompanyCustomer: (companyId, customerId) => {
    return AxiosBusiness.post(`company/${companyId}/customer/${customerId}`)
  },

  deleteCompanyCustomer: (companyId, customerId) => {
    return AxiosBusiness.delete(`company/${companyId}/customer/${customerId}`)
  },

  getCompanyCustomer: (companyId, customerId) => {
    return AxiosBusiness.get(`company/${companyId}/customer/${customerId}`)
  },
}
